import React from 'react';
import { Result, Button } from 'antd';

export function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <Result
      status="500"
      title="OOPS"
      subTitle="Sorry, something went wrong."
      extra={<Button type="primary" onClick={resetErrorBoundary}>Về trang chính</Button>}
    />
  );
}

export function handleError(error, info) {
  if (error.name === 'ChunkLoadError') {
    window.location.reload();
  }
}

export function handleReset() {
  window.location.href = window.location.origin;
}
